import { DateHelpers } from '@edl-development/edl-common';
import { Schedule } from './schedule.model';
export class SchoolYearSchedule extends Schedule {

    constructor(){
        super();
        let now = new Date;
        this.StartDate = DateHelpers.DateToShortDate(now.getMonth() < 6 ? new Date (now.getFullYear() - 1 + "/07/01") : new Date (now.getFullYear() + "/07/01"));
        this.EndDate = DateHelpers.DateToShortDate(now.getMonth() < 6 ? new Date (now.getFullYear()  + "/06/30") : new Date ((now.getFullYear()+1) + "/06/30"));
    }
}